// export const primaryDark = "#454C55";
// export const primaryDark = "#2a2d35";
// export const primaryDark = "rgb(42,45,59)";
export const primaryDark = "rgb(31,31,31)";
export const primaryDarkLight = "#1f1f1f";
export const mainYellow = "#acd444";
export const mainBlue = "#19d0e6";
export const mainBlueLight = "#098696";
// export const mainYellow = "#19d0e6";
